import React, { useEffect, useState } from 'react'
// Redux
import { useDispatch, useSelector } from 'react-redux'
import {
  getSearchOrder,
  setLimit,
  setPage,
  setSort,
  setSortOrder,
} from '../../features/order/orderSlice'
import {
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaChevronDown,
  FaSort,
} from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import SpinnerComp from '../util/SpinnerComp'
import OrderCell from './OrderCell'

const OrderTable = () => {
  const header = [
    '注文日',
    '注文番号',
    '印刷ステイタス',
    'ステイタス',
    'お客様番号',
    '都道府県',
    '部数',
    '折込日',
    '詳細',
    '一括注文',
  ]
  const { token, distribution_status } = useSelector((state) => state.auth)
  const {
    orderLoading,
    order,
    // Search/Sort
    order_key,
    user_id,
    status,
    //
    page,
    limit,
    sort_key,
    sort_order,
    company_id,
  } = useSelector((state) => state.order)
  const orderData = order?.value.order
  const dustributionStatus = distribution_status?.value?.status_list
  const printStatus = distribution_status?.value?.printing_status_list

  const dataSort = {
    order_key,
    user_id,
    status,
    //
    page,
    limit,
    sort_key,
    sort_order,
    company_id,
  }

  const dispatch = useDispatch()
  const [isClick, setIsClick] = useState(false)
  const onClickSort = (head) => {
    setIsClick(true)
    switch (head) {
      case '注文番号':
        if (sort_order === 'desc') {
          dispatch(setSort('order_key'))
          dispatch(setSortOrder('asc'))
        } else if (sort_order === 'asc') {
          dispatch(setSort('order_key'))
          dispatch(setSortOrder('desc'))
        }
        break
      case '注文日':
        if (sort_order === 'desc') {
          dispatch(setSort('created_at'))
          dispatch(setSortOrder('asc'))
        } else if (sort_order === 'asc') {
          dispatch(setSort('created_at'))
          dispatch(setSortOrder('desc'))
        }
        break
      case 'ステイタス':
        if (sort_order === 'desc') {
          dispatch(setSort('status'))
          dispatch(setSortOrder('asc'))
        } else if (sort_order === 'asc') {
          dispatch(setSort('status'))
          dispatch(setSortOrder('desc'))
        }
        break
      case '部数':
        if (sort_order === 'desc') {
          dispatch(setSort('quantity'))
          dispatch(setSortOrder('asc'))
        } else if (sort_order === 'asc') {
          dispatch(setSort('quantity'))
          dispatch(setSortOrder('desc'))
        }
        break
      case '折込日':
        if (sort_order === 'desc') {
          dispatch(setSort('insertion_date'))
          dispatch(setSortOrder('asc'))
        } else if (sort_order === 'asc') {
          dispatch(setSort('insertion_date'))
          dispatch(setSortOrder('desc'))
        }
        break
      case 'お客様番号':
        if (sort_order === 'desc') {
          dispatch(setSort('user_id'))
          dispatch(setSortOrder('asc'))
        } else if (sort_order === 'asc') {
          dispatch(setSort('user_id'))
          dispatch(setSortOrder('desc'))
        }
        break
      // eslint-disable-next-line
      default:
        return
    }
    // dispatch(setSort())
  }

  useEffect(() => {
    if (isClick) dispatch(getSearchOrder({ data: dataSort, token }))
    setIsClick(false)
    // eslint-disable-next-line
  }, [sort_key, sort_order])

  const navigate = useNavigate()
  const toDetail = (orderId) => {
    navigate(`/order/detail/${orderId}`)
  }

  const [openBulk, setOpenBulk] = useState(null)

  let dataRaw = []

  for (let i = 1; i <= orderData.length; i++) {
    let iPlus = i - 1
    if (
      orderData[iPlus][0][0].extra?.bulk_type_id === 1 ||
      orderData[iPlus][0][0].extra?.bulk_type_id === 2 ||
      orderData[iPlus][0][0].extra?.bulk_type_id === 3
    ) {
      // console.log(orders[iPlus][0], "ini data");
      const dataArray = []
      orderData[iPlus].forEach((data2d) => {
        data2d.forEach((data) => {
          dataArray.push(data)
        })
      })
      dataRaw.push(dataArray)
    } else {
      if (
        Array.isArray(orderData[iPlus][0]) &&
        orderData[iPlus][0].length > 1
      ) {
        const dataArray = []
        orderData[iPlus].forEach((data2d) => {
          data2d.forEach((data) => {
            dataArray.push(data)
          })
        })
        dataRaw.push(dataArray)
      } else {
        dataRaw.push(orderData[iPlus][0][0])
      }
    }
  }

  // console.log(dustributionStatus)

  // Pagination
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  // const [itemOffset, setItemOffset] = useState(0)
  // const [itemsPerPage, setItemsPerPage] = useState(10)

  // Simulate fetching items from another resources.
  // (This could be items from props; or items loaded in a local state
  // from an API endpoint with useEffect and useState)
  // const endOffset = itemOffset + limit
  // const currentItems = orderData?.slice(itemOffset, endOffset)
  const currentItems = orderData ? orderData : []
  // const pageCount = Math.ceil(orderData?.length / limit)
  const pageCount = Math.ceil(order?.value?.total_pages)

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    dispatch(setPage(Number(event.selected + 1)))
    // const newOffset = (event.selected * limit) % orderData.length
    // console.log(`Loading items from ${itemOffset} to ${endOffset}`)
    // setItemOffset(newOffset)
  }

  // console.log(currentItems)

  return (
    <>
      <div className="flex gap-2 items-center py-2">
        <label htmlFor="items_per_page pr-2">Show </label>
        <select
          name="items_per_page"
          id="items_per_page"
          // onChange={(e) => setItemsPerPage(e.target.value)}
          value={limit}
          onChange={(e) => {
            dispatch(setPage(Number(1)))
            dispatch(setLimit(Number(e.target.value)))
          }}
          className="bg-white border-[1px] border-black px-[2px] rounded-sm"
        >
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        <p>entries</p>
      </div>
      {orderLoading ? (
        <SpinnerComp />
      ) : (
        <div className="w-full relative overflow-x-auto">
          <table className="w-full table-auto min-w-[920px] overflow-x-auto">
            <thead>
              <tr className="text-center">
                {header.map((head, idx) => (
                  <th
                    onClick={() => onClickSort(head)}
                    key={idx}
                    className="relative min-w-[120px] py-2 text-xs font-bold border-[1px] border-black cursor-pointer"
                  >
                    <div className="flex justify-center items-center gap-2">
                      {head}
                      <span className="">
                        <FaSort />
                      </span>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {dataRaw.map((order) =>
                Array.isArray(order) ? (
                  <>
                    <OrderCell orders={order} toDetail={toDetail} />
                  </>
                ) : (
                  <tr
                    key={order?.order_key}
                    onClick={() => toDetail(order?.order_key)}
                    className="text-center text-sm border-[1px] border-gray-400 bg-gray-100 hover:bg-gray-800 hover:text-white cursor-pointer"
                  >
                    <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
                      {order?.created_at}{' '}
                    </td>
                    <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
                      {order?.order_key}
                    </td>
                    <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
                      {/* {order?.data_type === 'orikomi_print' ? (
                        <>
                        {printStatus?.map(
                          (status, idx) => idx === order?.printing_status && status
                        )}
                        </>
                      ) : '-'} */}
                    </td>
                    <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
                      {dustributionStatus?.map(
                        (status, idx) => idx === order?.status && status 
                      )}
                    </td>
                    <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
                      {order?.user_id}
                    </td>
                    <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
                      {order?.extra?.points?.length > 0
                        ? order?.extra?.points
                        : ''}
                    </td>
                    <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
                      {order?.estimation?.quantity}
                    </td>
                    <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
                      {order?.insertion_date}
                    </td>
                    <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
                      {order?.extra?.sync?.product_name}
                    </td>
                    <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]"></td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      )}
      {/* Pagination */}
      <ReactPaginate
        forcePage={page - 1}
        breakLabel={'...'}
        activeClassName={
          'flex justify-center items-center text-orange-500 text-black font-bold'
        }
        containerClassName={
          'flex justify-center items-center mx-auto mt-4 text-lg text-gray-500'
        }
        disabledClassName={'text-gray-500'}
        marginPagesDisplayed={2}
        nextClassName={''}
        nextLabel={
          <div className="flex gap-2 items-center px-2 border shadow-md h-[40px] rounded-[12px] ml-4 font-semibold text-black">
            <p>次へ</p>
            <FaAngleDoubleRight style={{ fontSize: 18, width: 20 }} />
          </div>
        }
        onPageChange={handlePageClick}
        pageCount={pageCount || 0}
        pageClassName={
          'flex justify-center items-center font-semibold mx-[4px] border px-2 w-[40px] h-[40px] text-sm rounded-full shadow-md'
        }
        pageRangeDisplayed={2}
        previousClassName={''}
        previousLabel={
          <div className="flex gap-2 items-center px-2 border shadow-md h-[40px] rounded-[12px] mr-4 font-semibold text-black">
            <FaAngleDoubleLeft style={{ fontSize: 18, width: 20 }} />
            <p>前へ</p>
          </div>
        }
      />
    </>
  )
}

export default OrderTable
